import { render, staticRenderFns } from "./SetCustomDoc.vue?vue&type=template&id=019c4010&scoped=true"
import script from "./SetCustomDoc.vue?vue&type=script&lang=js"
export * from "./SetCustomDoc.vue?vue&type=script&lang=js"
import style0 from "./SetCustomDoc.vue?vue&type=style&index=0&id=019c4010&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019c4010",
  null
  
)

export default component.exports